import { Injectable } from '@angular/core';
import { RegisterUserService } from 'src/app/services/registerUser/register-user.service';
import { Router } from '@angular/router';
import { RegisterService } from './register/register.service';
import { CommonFunctionService } from './Common/common-function.service';
const swal = require('sweetalert');
@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private checkInterval: any; // Interval handle for checking remaining time  

  constructor(
    public registerUserService: RegisterUserService,
    private router: Router, private commonfunction: CommonFunctionService,
    private service: RegisterService,
  ) { }

  startSessionTimeout(): void {
    this.checkRemainingTime();
    this.checkInterval = setInterval(() => {
      this.checkRemainingTime();
    }, 60000);
  }

  private checkRemainingTime(): void {
    let logoutTime: number = this.commonfunction.getUserMerchantData().expireTime;
    console.log("logoutTime",logoutTime);
    
    const currentUnixTimestamp = Math.floor(Date.now() / 1000);
    const remainingTime = logoutTime - currentUnixTimestamp;
    // const remainingTime = 200; // 1724221597
    if (remainingTime <= 300 && remainingTime > 0) { // 300 seconds = 5 minutes
      this.showSessionExpiryPopup();
    } else if (remainingTime <= 0) {
      this.logoutUser();
    }
  }

  private showSessionExpiryPopup(): void {
    swal({
      title: 'Your session will be expire soon, do you want to continue?',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Close!',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Yes!',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.refreshSession();
      }
    });
  }

  refreshSession(): void {
    let form = { username: "", password: "", userType: "", IpAddress: "", ResellerUrl: "", DeviceType: "", GeoLocation: "", AppVersion: "", };

    form.userType = 'Merchant';
    form.AppVersion = "MPORTAL"
    this.service.RefreshToken(form).subscribe(res => {
      if (typeof (res) == 'object') {
        this.logoutUser()
      }
      else {
        localStorage.setItem('VirtualPOSToken', String(res));
      }
    });
  }

  logoutUser(): void {
    this.router.navigate(['/login']);
  }

  stopSessionTimeout(): void {
    clearInterval(this.checkInterval);
  }

}
